import { render, staticRenderFns } from "./view-exam-modal.vue?vue&type=template&id=2511d029&scoped=true"
import script from "./view-exam-modal.vue?vue&type=script&lang=js"
export * from "./view-exam-modal.vue?vue&type=script&lang=js"
import style0 from "./view-exam-modal.vue?vue&type=style&index=0&id=2511d029&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511d029",
  null
  
)

export default component.exports